import { FrontendVariables } from "@Front/Config/VariablesFront";
import {
	debugLog,
	ensureLeadingSlash,
	normalizeHost,
	normalizeProtocol,
	rewriteBackApiHostWhenApiSubdomainMirrorsPage,
	trimTrailingSlash,
	withDefault,
} from "@Front/Config/configRuntimeUrlHelpers";
import {
	applyPublicConfigPayloadToFrontendVariables,
	invalidateBaseApiUrlAfterConfigUpdate,
} from "@Front/Config/configRuntimeApplyPayload";
import { fetchWithNetworkLogging } from "@Front/Api/helpers/requestHelpers";

export async function performPublicConfigHttpLoad(markLoadedAt: () => void): Promise<void> {
	const instance = FrontendVariables.getInstance();

	const protocol = normalizeProtocol(instance.BACK_API_PROTOCOL) || `${window.location.protocol}//`;
	const backHostForFetch = rewriteBackApiHostWhenApiSubdomainMirrorsPage(window.location.host, instance.BACK_API_HOST);
	const { host, inferredRoot, inferredVersion } = normalizeHost(backHostForFetch, protocol, window.location.host);
	const rootUrl = ensureLeadingSlash(withDefault(instance.BACK_API_ROOT_URL ?? inferredRoot, "/api"));
	const version = ensureLeadingSlash(withDefault(instance.BACK_API_VERSION ?? inferredVersion, "/v1"));

	let baseUrl: string;
	try {
		baseUrl = new URL(`${trimTrailingSlash(rootUrl)}${version}`, `${protocol}${host}`).toString().replace(/\/$/, "");
	} catch {
		return;
	}

	const url = `${baseUrl}/public/config`;

	debugLog("ConfigRuntime", { protocol, host, rootUrl, version, baseUrl, url });

	try {
		const res = await fetchWithNetworkLogging(url, { credentials: "omit", method: "GET" }, { invokeUserFacingErrorHandler: false });
		if (!res.ok) return;
		const payload = await res.json();
		const cfg: Record<string, string> = payload?.config || {};

		debugLog("ConfigRuntime:payload", cfg);

		const hasUpdate = applyPublicConfigPayloadToFrontendVariables(instance, cfg);
		await invalidateBaseApiUrlAfterConfigUpdate(hasUpdate);
		markLoadedAt();
	} catch {
		// silent: keep build/env defaults
	}
}
